GenderService = ($filter)->
  get: ->
    genders = [
      {key: 'male',   value: $filter('translate')('_REGISTRATION.NEW.MALE')}
      {key: 'female', value: $filter('translate')('_REGISTRATION.NEW.FEMALE')}
    ]
    genders
GenderService.$inject = [
  '$filter'
]
module.exports = GenderService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/gender-service.coffee